import { Component, OnInit } from '@angular/core';
import { BaseLoginComponent } from 'src/app/shared/components/base-login/base-login.component';
import {
  errorDescriptionsMap,
  getOptionsFromRedirectUri,
} from 'src/app/shared/utils';
import { environment } from 'src/environments/environment';
import { EnvironmentType } from 'src/environments/environmentTypes';

@Component({
  selector: 'app-connect-doctors-id',
  templateUrl: './connect-doctors-id.component.html',
  styleUrls: ['./connect-doctors-id.component.css'],
})
export class ConnectDoctorsIdComponent
  extends BaseLoginComponent
  implements OnInit {
  config: EnvironmentType['apps'][0]['cportal-connect-config'] = environment
    .apps[this.clientId]?.['cportal-connect-config'] || {
    passwordResetUrl: '',
  };

  isNoCodeInput?: boolean;

  stepState: {
    currentStepNumber: number;
    steps: string[];
  } = {
      currentStepNumber: 4,
      steps: ['規約', 'コード入力', '基本情報', 'ID連携', '専門情報', '内容確認'],
    };

  async init(): Promise<void> {
    const optionsFromUrl = getOptionsFromRedirectUri(this.redirectUri);
    // https://doctors-jp.backlog.com/view/CBPT-4152 向け対応
    this.handleNoInputFlow(optionsFromUrl.cpNoCodeInput);

    // パラメータ指定がある場合は新規登録フローなので、自動ログインしない
    if (optionsFromUrl.email || optionsFromUrl.option) {
      setTimeout(() => {
        this.setDefaultEmailFromQuery();
      }, 0);
      // initializedフラグは時前で立てる必要がある
      this.initialized = true;
      return;
    }
    // ここに入るのはログインの場合
    await this.autologin();
  }

  private handleNoInputFlow(cpNoCodeInput?: boolean) {
    this.isNoCodeInput = cpNoCodeInput;
    if (this.isNoCodeInput) {
      setTimeout(() => {
        // 変数初期化のタイミングが遅いため、setTimeoutで次のイベントループに回す
        this.stepState.currentStepNumber = 3;
        this.stepState.steps = this.stepState.steps.filter(
          (e) => e !== 'コード入力'
        );
      }, 0);
    }
  }

  back() {
    // urlにcodeが含まれているため取得する
    const optionsFromUrl = getOptionsFromRedirectUri(this.redirectUri);
    const code = optionsFromUrl.option?.split('code:')[1];

    // 直接リンクするためにCPのドメイン部分を取得する.
    const config = this.getCportalConfig();

    if (!config) return;
    // https://stg-dx.collaboportal.com/signup/basic?code=818309eb-1983-4422-8bc9-620122c35f3a
    // のようにリダイレクトする

    // 末尾スラッシュを削除
    const appUrl = config.appUrl.replace(/\/$/, '');
    location.href = `${appUrl}/signup/basic?code=${code}`;
  }

  getCportalConfig() {
    for (const [clientId, app] of Object.entries(environment.apps)) {
      if (ConnectDoctorsIdComponent.isCportalConfig(app, this.clientId)) {
        return app;
      }
    }
    return undefined;
  }

  // environmentsの設定から、このconnect設定に関連するclientIdかどうかを判定する
  static isCportalConfig(
    app: EnvironmentType['apps'][0],
    targetClientId: string
  ) {
    // if (app.type !== 'cportal') return false;
    const config = app['cportal-connect-config-for-collaboportal'];
    if (!config) return false;
    if (config.clientId !== targetClientId) return false;

    return true;
  }

  protected get errorDescripitionsMap(): typeof errorDescriptionsMap {
    return {
      'Wrong email or password.': '正しいパスワードを入力してください',
      'Missing credentials': errorDescriptionsMap['Missing credentials'],
      "Your account has been blocked after multiple consecutive login attempts. We've sent you an email with instructions on how to unblock it.":
        errorDescriptionsMap[
        "Your account has been blocked after multiple consecutive login attempts. We've sent you an email with instructions on how to unblock it."
        ],
      "Your account has been blocked after multiple consecutive login attempts. We've sent you a notification via your preferred contact method with instructions on how to unblock it.":
        errorDescriptionsMap[
        "Your account has been blocked after multiple consecutive login attempts. We've sent you a notification via your preferred contact method with instructions on how to unblock it."
        ],
    };
  }
}
